import React from "react";
import { Row, Col } from 'react-bootstrap';
import { IPlanEventData } from "../../types/api/eventApi";
import { t } from "i18next";

const EventPlan: React.FC<{ plan_event: IPlanEventData }> = ({ plan_event }) => {
    return (
        <div>
            <div>
                <section className='plan-section'>
                    <div className="container">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <div className="plan-img">
                                    <img src={plan_event.image} alt="img" className="img-fluid"></img>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="plan-content ps-2">
                                    <h3 className="title">{t('meeting_event.plan_event.name')}</h3>
                                    <p className="text">{t('meeting_event.plan_event.description')}</p>
                                    <button className="btn btn-gold" onClick={() => window.location.href = plan_event.link}>{t('meeting_event.plan_event.inquiry_now')}</button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default EventPlan;